// extracted by mini-css-extract-plugin
export default {"trainBlock":"ErrorCorrectionBlock_trainBlock__D62Vg","screencast":"ErrorCorrectionBlock_screencast__LLvfw"};